import { render, staticRenderFns } from "./Klanten.vue?vue&type=template&id=50e49fb3&"
import script from "./Klanten.vue?vue&type=script&lang=js&"
export * from "./Klanten.vue?vue&type=script&lang=js&"
import style0 from "./Klanten.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports